import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";
interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupCommodityWaybills = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  selectedCatalog,
  setSelectedCatalog,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.CommodityWaybills.getDataService().GetAll(
      searchText
    );
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.CommodityWaybills}
        width={width}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
      </NFLookupCatalog>
    </>
  );
};
